import { TestDocumentation, TestType } from "../graphql/baseTypes";

export enum TestReason {
  R1 = "freie Testdurchführung",

  R2 = "Kind unter 5 J.",

  R3 = "Beendigung der Quarantäne",

  R4 = "Leistungsberechtigt n. §29 SGB IX",

  R5 = "med. Gründen nicht geimpfte Person",

  R6 = "klinische Probanden von COVID Impfstoffen",

  R7 = "pflegende Angehörige Person",

  R8 = "Berucher:innen von Kliniken, ambulante Einrichtungen oder für Pflege oder Menschen mit Behinderung",

  R9 = "Schwangere in ersten 3 Monaten",

  R10 = "Haushaltsangehörige von nachweislich infizierten (nicht Arbeitgeber)",

  R11 = "Überwachung e. Tests zur Eigenanwendung",
}

export const TEST_TYPE_TEXT: { [key in keyof typeof TestType]: string } = {
  self_test_antigen:
    "Sellbstdurchführung mit Überwachung von SARS-CoV2 PoC-Antigen-Testabnahme",
  test_antigen:
    "Abnahme durch Testabnahmeberechtigten von SARS-CoV2 PoC-Antigen-Test",
  test_pcr: "Abnahme durch Testabnahmeberechtigten von SARS-CoV2 PCR-Test",
  test_distribution: "§4 Verhütung der Verbreitung",
  test_citizen: "§4a Bürgertestung",
};

export const PRE_FILLS: {
  [key in TestReason]: Omit<
    TestDocumentation,
    "type" | "reason" | "__typename"
  >;
} = {
  [TestReason.R1]: {
    paymentRequired: true,
    noPaymentRequiredProof: "keine Nachweispflicht",
    paymentRecived: true,
  },
  [TestReason.R2]: {
    paymentRequired: false,
    noPaymentRequiredProof: "Geburtsurkunde, Kinderreisepass",
    paymentRecived: false,
  },
  [TestReason.R3]: {
    paymentRequired: false,
    noPaymentRequiredProof: "PCR-Test",
    paymentRecived: false,
  },
  [TestReason.R4]: {
    paymentRequired: false,
    noPaymentRequiredProof: "formlose Selbstauskunft, entspr. Bescheid",
    paymentRecived: false,
  },
  [TestReason.R5]: {
    paymentRequired: false,
    noPaymentRequiredProof: "ärztliches Zeugnis im Original",
    paymentRecived: false,
  },
  [TestReason.R6]: {
    paymentRequired: false,
    noPaymentRequiredProof: "Teilnahme-Nachweis",
    paymentRecived: false,
  },
  [TestReason.R7]: {
    paymentRequired: false,
    noPaymentRequiredProof: "formlose Selbstauskunft, Beleg des Pflegestatus",
    paymentRecived: false,
  },
  [TestReason.R8]: {
    paymentRequired: false,

    noPaymentRequiredProof: "Selbstauskunft",
    paymentRecived: false,
  },
  [TestReason.R9]: {
    paymentRequired: false,
    noPaymentRequiredProof: "Mutterpass",
    paymentRecived: false,
  },
  [TestReason.R10]: {
    paymentRequired: false,
    noPaymentRequiredProof: "Nachweis übereinstimmende Wohnanschrift",
    paymentRecived: false,
  },
  [TestReason.R11]: {
    paymentRequired: false,
    noPaymentRequiredProof: "Selbstauskunft",
    paymentRecived: false,
  },
};

type TestReasonIndex = TestReason | undefined;

export const getTestTypeFromValue = (value: string): TestType =>
  Object.keys(TEST_TYPE_TEXT).find(
    (key) => TEST_TYPE_TEXT[key as TestType] === value
  ) as TestType;

export const getValuesForSelectedTestReason: (
  type: TestType,
  reason: TestReasonIndex
) => TestDocumentation = (type, reason) => {
  if (type === TestType.self_test_antigen || !reason) {
    return {
      type,
    };
  }

  return {
    reason: reason,
    type,
    ...PRE_FILLS[reason],
  };
};
